module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00479.90d8212a.jpg";